import * as React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

export interface AuthRedirectMessageProps {
  type: AuthRedirectMessageType;
}

export interface AuthRedirectMessageState {
  /* empty */
}

export enum AuthRedirectMessageType {
  RedirectToSignUp,
  RedirectToLogin
}

export class AuthRedirectMessage extends React.Component<
  AuthRedirectMessageProps,
  AuthRedirectMessageState
> {
  render() {
    const isSignUp =
      this.props.type === AuthRedirectMessageType.RedirectToSignUp;

    return (
      <span className="auth-redirect-message">
        {isSignUp ? `Don't have an account? ` : `Already have an account? `}
        <Link
          className="edge-of-play-link auth-redirect-link"
          to={isSignUp ? '/sign-up' : '/login'}
        >
          {isSignUp ? `Sign up now!` : `Log in now!`}
        </Link>
      </span>
    );
  }
}

export default AuthRedirectMessage;



// WEBPACK FOOTER //
// ./src/app/components/Auth/AuthRedirectMessage/index.tsx